/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CnvFileRealAssetTracklineConfig = {
    type: CnvFileRealAssetTracklineConfig.type;
    /**
     *
     * Regular expression pattern to locate SeaBird CTD cast files.
     * Files must contain lat/lon coordinates and timestamps.
     *
     * Example: "Vessel/Oceanographic/CTD/{{external_id}}/PROC/.*?\d+\.cnv"
     *
     */
    pattern: string;
};

export namespace CnvFileRealAssetTracklineConfig {

    export enum type {
        CNV_FILE = 'cnv_file',
    }


}

